import React, { useState } from 'react';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import UserManagement from '../../../components/siteadmin/UserManagement';

import s from './Users.css';

const Users = (props) => {

  const [state, setState] = useState({ currentPage: 1, searchList: '', userType: '' });

  const setStateVariable = (variables) => {
    setState(prev => ({
      ...prev,
      ...variables
    }));
  };

  const { title } = props;
  const { currentPage, searchList, userType } = state;

  return <UserManagement
    title={title}
    currentPage={currentPage}
    searchList={searchList}
    userType={userType}
    setStateVariable={setStateVariable} />;
}

export default compose(
  withStyles(s)
)(Users);
